import React from "react";
import { useSelector, useDispatch } from "react-redux";
import { Button, ButtonGroup, ClickAwayListener, Grid, Grow, makeStyles, MenuItem, MenuList, Paper, Popper } from '@material-ui/core'
import AddIcon from '@material-ui/icons/Add';
import ArrowDropDownIcon from '@material-ui/icons/ArrowDropDown';
import { CertificadoAfiliadoItem } from "./CertificadoAfiliadoItem";
import { certificadoInsertStart } from "../../actions/certificados";

const useStyles = makeStyles((theme) => ({
  container: {
    width: "80vw",
  },

  divContenedor: {
    width: 600,
    height: 600,
  },
  gridNone: {
    pointerEvents: 'none',
    opacity: 0.4,
  }
}));

const tiposCert=[
  {
    id:1,
    descripcion:"ESTUDIO"
  },
  {
    id:2,
    descripcion:"DISCAPACIDAD"
  },
  {
    id:3,
    descripcion:"PMI"
  }
]
export const CertificadosAfiliado = (props) => {
  const classes = useStyles();
  const dispatch = useDispatch();
  const { afiliado } = useSelector((state) => state.afiliacion);
  const { cargada, items: certificados } = useSelector((state) => state.certificadosAfiliacion);

  const [open, setOpen] = React.useState(false);
  const anchorRef = React.useRef(null);
  const [selectedIndex, setSelectedIndex] = React.useState(0);

  const handleMenuItemClick = (event, index) => {
    setSelectedIndex(index);
    setOpen(false);
  };

  const handleToggle = () => {
    setOpen((prevOpen) => !prevOpen);
  };

  const handleClose = (event) => {
    if (anchorRef.current && anchorRef.current.contains(event.target)) {
      return;
    }
    setOpen(false);
  };

  const handleCertificadoInsertar = (idTipo) => {
    const initialCertificate = {
      idAfiliado: afiliado.id_afiliado,
      tipoCertificado: idTipo,
      fecha: null,
      fechaNacimiento: null,
      fechaRealParto: null,
      fechaProbableParto: null,
      fechaVencimiento: null,
      fecha2doVencimiento: null,
      fechaActualizacion: null,
      madreHijo: false,
    }
    dispatch(certificadoInsertStart(initialCertificate));
  };
  
  return (
    <div className={props.idForm === 'formConsulta' ? classes.gridNone : null}>
      <Grid
        container
        direction="row"
        justify="space-between"
        alignItems="center"
      >
        <Grid item xs={12}>
          <ButtonGroup variant="contained" color="secondary" ref={anchorRef} aria-label="split button">
            <Button component="span" variant="contained" color="inherit" startIcon={<AddIcon />} style={{ borderRadius: "3px 0px 0px 3px" }} onClick={()=>handleCertificadoInsertar(tiposCert[selectedIndex].id)}>{tiposCert[selectedIndex].descripcion}</Button>
            <Button
              color="inherit"
              size="small"
              aria-controls={open ? 'split-button-menu' : undefined}
              aria-expanded={open ? 'true' : undefined}
              aria-label="select merge strategy"
              aria-haspopup="menu"
              onClick={handleToggle}
            >
              <ArrowDropDownIcon />
            </Button>
          </ButtonGroup>
          <Popper open={open} anchorEl={anchorRef.current} role={undefined} transition disablePortal style={{ zIndex: 1 }}>
            {({ TransitionProps, placement }) => (
              <Grow
                {...TransitionProps}
                style={{
                  transformOrigin: placement === 'bottom' ? 'center top' : 'center bottom',
                }}
              >
                <Paper>
                  <ClickAwayListener onClickAway={handleClose}>
                    <MenuList id="split-button-menu">
                    {tiposCert.map((option, index) => (
                          <MenuItem
                              key={option.id}
                              selected={index === selectedIndex}
                              onClick={(event) => handleMenuItemClick(event, index)}
                          >
                              {option.descripcion}
                          </MenuItem>
                      ))}
                    </MenuList>
                  </ClickAwayListener>
                </Paper>
              </Grow>
            )}
          </Popper>

        </Grid>
        <Grid item xs={12}>
          {
            cargada && certificados.length > 0 &&
            certificados
              .sort((a, b) => {
                if (!a.fecha && b.fecha) return -1;
                if (a.fecha && !b.fecha) return 1;
                if (a.fecha && b.fecha) return new Date(b.fecha) - new Date(a.fecha);
                return 0;
              })
              .map((item) => (
                <CertificadoAfiliadoItem key={item.idItem} item={item} />
            ))
          }
        </Grid>
      </Grid>
    </div>
  );
};

